/**
 * Definición central de rutas.
 *
 * Públicas:  /login, /register, /reset-password, /reset-password/confirm
 * Protegidas: / (home), /plan, /plan/sesion/:sessionId, /plan/crear,
 *             /carreras (v15.5-§8.3.C), /perfil, /onboarding
 * Fallback:  cualquier otra → NotFound (sin ruta dedicada /404).
 *
 * s64: ProtectedRoute monta la barra inferior móvil (Inicio · Plan ·
 * Carreras) en todas las protegidas salvo /onboarding (bottomNav={false}).
 */

import { Routes, Route } from "react-router-dom";

import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Home } from "@/pages/Home";
import { PrivacyPage } from "@/pages/Legal/PrivacyPage";
import { TermsPage } from "@/pages/Legal/TermsPage";
import { Login } from "@/pages/Login";
import { NotFound } from "@/pages/NotFound";
import { OnboardingPage } from "@/pages/Onboarding/OnboardingPage";
import { CreatePlanPage } from "@/pages/Plan/CreatePlanPage";
import { PlanPage } from "@/pages/Plan/PlanPage";
import { SessionDetailPage } from "@/pages/Plan/SessionDetailPage";
import { ProfilePage } from "@/pages/Profile/ProfilePage";
import { RacesPage } from "@/pages/Races/RacesPage";
import { Register } from "@/pages/Register";
import { ResetPassword } from "@/pages/ResetPassword";
import { ResetPasswordConfirm } from "@/pages/ResetPasswordConfirm";

export function AppRoutes() {
  return (
    <Routes>
      {/* Públicas */}
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/reset-password/confirm" element={<ResetPasswordConfirm />} />
      {/* Legales (S14.2 R1 GDPR): públicas — deben leerse antes de registrarse. */}
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/terms" element={<TermsPage />} />

      {/* Protegidas */}
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Home />
          </ProtectedRoute>
        }
      />
      <Route
        path="/plan"
        element={
          <ProtectedRoute>
            <PlanPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/plan/crear"
        element={
          <ProtectedRoute>
            <CreatePlanPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/plan/sesion/:sessionId"
        element={
          <ProtectedRoute>
            <SessionDetailPage />
          </ProtectedRoute>
        }
      />
      {/* s64: sin barra inferior — el onboarding es un flujo lineal,
          no una pantalla de la app navegable. */}
      <Route
        path="/onboarding"
        element={
          <ProtectedRoute bottomNav={false}>
            <OnboardingPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/perfil"
        element={
          <ProtectedRoute>
            <ProfilePage />
          </ProtectedRoute>
        }
      />
      {/* v15.5-§8.3.C: listado de race_targets del atleta. */}
      <Route
        path="/carreras"
        element={
          <ProtectedRoute>
            <RacesPage />
          </ProtectedRoute>
        }
      />

      {/* Fallback */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
